module.exports = __webpack_public_path__ + "static/media/homepage_top_banner_img.eabfbde1.png";